$(function() {

    $.video = {};

    // durations

    $.video.calculateCircleMove = function() {
        var move = $(window).innerHeight() * 2;
        return move;
    };
    
    $.video.calculateDotMove1 = function() {
        var move = $(window).innerHeight();
        move = Math.round(move / 3) * 2 + $(window).innerHeight();
        return move;
    };

    $.video.calculateDotMove2 = function() {
        var move = $(window).innerHeight();
        move = move * 2 + $(window).innerHeight();
        return move;
    };

    // timelines

    $.video.tl = {};

    // start
        
    $.video.tl.in = new TimelineMax();

    $.video.tl.in.addLabel("start");

    $.video.nextSectionID = $("#video-container").next('section').attr('id');
    $.video.tl.in.set("#"+ $.video.nextSectionID, { visibility: "visible" }, "start");

    new ScrollMagic.Scene({ triggerElement: '#video-start', triggerHook: 'onEnter', duration: '100%' })
    	.setTween($.video.tl.in)
    	// .addIndicators({name: 'video start'})
        .addTo($.controller);

    // shapes
    
    $.video.tl.shapes = new TimelineMax();

    $.video.tl.shapes.addLabel("start");

    $.video.tl.shapes.set("#video-container", { visibility: "visible" }, "start");

    $.video.tl.shapes.from("#video-dots-01", 2, { y : $.video.calculateDotMove1 }, "shapes");
    $.video.tl.shapes.from("#video-circle", 2, { y: $.video.calculateCircleMove, delay: 0.5 }, "shapes");
    $.video.tl.shapes.from("#video-dots-02", 2, { y : $.video.calculateDotMove2, delay: 1 }, "shapes");

    new ScrollMagic.Scene({ triggerElement: '#video-start', triggerHook: 'onCenter', duration: '100%' })
        .setTween($.video.tl.shapes)
        // .addIndicators({name: 'video shapes'})
        .addTo($.controller);

});
